@if (options().length > 0) {
    <div class="flex w-full flex-row gap-16">
        @if (!only() || only() === 'min') {
            <ui-input-select
                class="flex-1"
                [options]="fromOptions()"
                [disabled]="disabled()"
                [selected]="range().from?.toString()"
                [withNullSelect]="withNullSelect()"
                [nullSelectCustomLabel]="nullSelectCustomLabel()"
                (selectedChange)="$event ? setFrom(+$event) : null"
                label="ab"
                ariaLabel="Unterer Wert"
            />
        }
        @if (!only() || only() === 'max') {
            <ui-input-select
                class="flex-1"
                [options]="toOptions()"
                [selected]="range().to?.toString()"
                [disabled]="disabled()"
                [withNullSelect]="withNullSelect()"
                [nullSelectCustomLabel]="nullSelectCustomLabel()"
                (selectedChange)="$event ? setTo(+$event) : null"
                label="bis"
                ariaLabel="Oberer Wert"
            />
        }
    </div>
}
